import React, { ButtonHTMLAttributes } from 'react'

import * as S from './chip.styled'

export type ChipVariant = 'default' | 'active' | 'red' | 'green'
export type ChipSize = 'medium' | 'small'

export type ChipProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: ChipVariant
  size?: ChipSize
  children: React.ReactNode
}

export const Chip = ({ variant, size = 'medium', children, ...rest }: ChipProps) => {
  return (
    <S.Button {...rest} $variant={variant} $size={size}>
      {children}
    </S.Button>
  )
}
